module.exports = __webpack_public_path__ + "71f40e98c6ad2cdc8063bedf8d2b5b7f.svg";